
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { VariazioneDaComunicare, TipoVariazione, RigaDistintaPerComunicazioneVariazione, ItemDatiLookup, RigaDistintaQtaTaglia, VariazioneDaComunicareQtaTaglia, Distinta, RigaDistinta } from '@/models';
import { store } from '@/store'
import TabellaValori from './TabellaValori.vue';
import VariazioniMassive from './VariazioniMassive.vue';

@Component({
    components:{
        TabellaValori,
        VariazioniMassive
    }
})
export default class DialogNewVariazione extends Vue{
    @Prop() private idDistinta!: string;      
    private nuovaVariazione: VariazioneDaComunicare = {
        rigaDistinta: {
            id: '',
        indiceRiga: 0,
        richiestaDiInserimento: true,
        innerRigaDistinta: {
            idParte: 'T',
            idComponenteBga: '',
            idColoreComponenteBgf: '',
            utilizzo: 'BASE',
            codFase: 'LBRB1',
            idDistinta: this.idDistinta,
            unMisuraDiBa: ''
        }
        },
        variazioneRigaDistintaQtaTaglia: [],
        tipoVariazione: TipoVariazione.NUOVA,
        valida: false,
        eliminataDaAs400: false,
        idDistintaAppartenenza: this.idDistinta,
        idModelloRiferimento: '',
        variazioniCorrelate: [],
        mostraCorrelate: false
    };
    private dialog: boolean = false;
    private valid: boolean = true;
    get unitaDiMisura(): ItemDatiLookup[] {
        return store.state.datiLookup!.umRigheDistinte;
    }

    open(){
        this.dialog = true;
    }
    
    updateQtaPerTagliaTemplate (qtaPerTagliaTemplate: RigaDistintaQtaTaglia[]) {
        this.nuovaVariazione.variazioneRigaDistintaQtaTaglia = [];
        qtaPerTagliaTemplate.forEach(variazione => {
            // inizializza la lista delle variazioni delle quantità per taglia per una possibile nuova variazione da comunicare
            this.nuovaVariazione.variazioneRigaDistintaQtaTaglia.push({
            indice: '',
            qta: 0,
            desc: variazione.desc,
            qtaModificata: 0
            });
        });

        // Creazione righe correlate per nuova variazione
        let correlate: VariazioneDaComunicare[] = [];
    
        let distinteCorrelate = store.state.uiConsumi.listaDistinteCorrelate;
        
        distinteCorrelate.forEach((distinta: Distinta) => {
          const maxIndice = Math.max(...distinta.righeDistintaDPC.map((r: RigaDistinta) => r.indiceRiga));
          if(distinta.id != this.nuovaVariazione.idDistintaAppartenenza) {
            // creo una variazione per la riga relativa allo stesso componente di quella di riferimento,
            // ma di un'altra distinta sempre legata al modello a cui è legata la variazione di riferimento
            var vCorrelata: VariazioneDaComunicare = {
              rigaDistinta: {
                id: '+/' + this.uuid(),
                indiceRiga: Math.max(...distinta.righeDistintaDPC.map((r: RigaDistinta) => parseInt(r.innerRigaDistinta.posizRiga)) || maxIndice) + 1,                
                richiestaDiInserimento: true,
                innerRigaDistinta: {
                    idParte: 'T',
                    idComponenteBga: this.nuovaVariazione.rigaDistinta.innerRigaDistinta.idComponenteBga,
                    idColoreComponenteBgf: this.nuovaVariazione.rigaDistinta.innerRigaDistinta.idColoreComponenteBgf,
                    utilizzo: 'BASE',
                    codFase: 'LBRB1',
                    idDistinta: distinta.id,
                    unMisuraDiBa: this.nuovaVariazione.rigaDistinta.innerRigaDistinta.unMisuraDiBa
                }
              },
              variazioneRigaDistintaQtaTaglia: [],
              tipoVariazione: TipoVariazione.NUOVA,            
              valida: true,
              eliminataDaAs400: false,
              idDistintaAppartenenza: distinta.id,
              idModelloRiferimento: distinta.idModello,
              variazioniCorrelate: [],
              mostraCorrelate: true // hack: per le correlate il campo viene usato per gestire lo stato
            };
            
            var rigaQtaTaglia = distinta.righeDistintaDPC.length > 0 ? 
              distinta.righeDistintaDPC[distinta.righeDistintaDPC.length -1].quantitaPerTaglia || [] :
              this.nuovaVariazione.variazioneRigaDistintaQtaTaglia;
              
            rigaQtaTaglia.forEach((qtaTaglia: RigaDistintaQtaTaglia) => {            
                let variazioneRigaDistintaQtaTaglia: VariazioneDaComunicareQtaTaglia = {
                  indice: qtaTaglia.indice,
                  desc: qtaTaglia.desc,
                  qta: qtaTaglia.qta,
                  qtaModificata: qtaTaglia.qta
                };              
                vCorrelata.variazioneRigaDistintaQtaTaglia.push(variazioneRigaDistintaQtaTaglia);
              });

            correlate.push(vCorrelata)
          }
        });

        this.nuovaVariazione.variazioniCorrelate = correlate;
    }

    @Emit('variazione-creata')
    private creaVariazione() {
      if ((this.$refs.form as HTMLFormElement).validate()) {

        this.nuovaVariazione.variazioniCorrelate.forEach((correlata: VariazioneDaComunicare) => {
          correlata.rigaDistinta.innerRigaDistinta.idComponenteBga = this.nuovaVariazione.rigaDistinta.innerRigaDistinta.idComponenteBga;
          correlata.rigaDistinta.innerRigaDistinta.idColoreComponenteBgf = this.nuovaVariazione.rigaDistinta.innerRigaDistinta.idColoreComponenteBgf;
          correlata.rigaDistinta.innerRigaDistinta.unMisuraDiBa = this.nuovaVariazione.rigaDistinta.innerRigaDistinta.unMisuraDiBa;
        });

        let nuovaVariazione: VariazioneDaComunicare = JSON.parse(
            JSON.stringify(this.nuovaVariazione)
        );

        nuovaVariazione.rigaDistinta.id = '+/' + this.uuid();

        this.dialog = !this.dialog;

        this.resetValidationFormCreaVariazione();
        this.resetFormCreaVariazione();

        return nuovaVariazione;
      }
    }

    private uuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
        });
    }

    private annullaVariazione() {
        this.dialog = !this.dialog;
        this.resetFormCreaVariazione();
        this.resetValidationFormCreaVariazione();
    }

    private resetFormCreaVariazione() {
        (this.$refs.form as HTMLFormElement).reset();
    }

    private resetValidationFormCreaVariazione() {
        (this.$refs.form as HTMLFormElement).resetValidation();
    }
}
